import { Flex, FormItem, Spacing, Switch, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { UmbrellaRole } from '@modules-deprecated/app/umbrellas/types/umbrellaRole'

import * as Styled from './styles'

interface RoleItemProps {
  role: UmbrellaRole
}

export const RoleItem = ({ role }: RoleItemProps): ReactElement => {
  return (
    <FormItem>
      <Flex gap={Spacing.S8}>
        <Switch key={role.id} value={role.id} />
        <Styled.TextWrapper>
          <Text weight="bold" colorVariant="secondary">
            {role.name}
          </Text>
          <Text colorVariant="secondary">{role.description}</Text>
        </Styled.TextWrapper>
      </Flex>
    </FormItem>
  )
}
